import { RegisteredComponent } from "@builder.io/sdk-react";

export const iframeEmbedCodeBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Iframe Embed Code",
  noWrap: true,
  inputs: [
    {
      name: "iframeContentType",
      type: "enum",
      enum: ["page", "elements", "demo"],
      friendlyName: "Iframe Content Type",
      localized: false,
    },
    {
      name: "campaignId",
      type: "string",
      friendlyName: "Campaign ID",
      localized: false,
      required: true,
      showIf: (options) => options.get("iframeContentType") === "demo",
    },
    {
      name: "iframeTitle",
      type: "string",
      friendlyName: "Title",
      defaultValue: "Embed content",
      localized: false,
      required: true,
    },
    {
      name: "trackAnalyticsInsideIframe",
      type: "boolean",
      defaultValue: false,
      localized: false,
      required: false,
    },
    {
      name: "allowFullScreen",
      type: "boolean",
      friendlyName: "Allow Full Screen",
    },
    {
      name: "iframeHeight",
      type: "number",
      friendlyName: "Height",
      localized: false,
      required: false,
    },
    {
      name: "iframeWidth",
      type: "number",
      friendlyName: "Width",
      localized: false,
      required: false,
    },
    {
      name: "iframeInitialHeight",
      type: "number",
      friendlyName: "Initial Height",
      helperText:
        "Used as the minimum height for HTML Content embeds and the fixed responsive height for Source URL embeds.",
      defaultValue: 600,
      localized: false,
      required: false,
    },
    {
      name: "iframeLoading",
      type: "enum",
      friendlyName: "Loading",
      enum: ["lazy", "eager"],
      defaultValue: "eager",
      localized: false,
      required: false,
    },
    {
      name: "iframeSrc",
      type: "string",
      friendlyName: "Source URL",
      helperText:
        "The URL of the page to embed in the iframe. Use 'HTML Content' or 'Source URL' (if both used, src has priority). Source URL embeds stay width-responsive and use Initial Height instead of auto-measuring content.",
      defaultValue: "",
      localized: false,
      required: false,
    },
    {
      name: "iframeContent",
      type: "longText",
      friendlyName: "HTML Content",
      helperText:
        "Any HTML content to inject into the iframe container (htmldoc, scripts, divs, etc.). HTML Content embeds auto-adjust their height.",
      defaultValue: "",
      localized: false,
      required: false,
    },
    {
      name: "containerId",
      type: "string",
      friendlyName: "Container ID",
      helperText:
        "The ID of the iframe container element (default: inner-iframe-container)",
      defaultValue: "inner-iframe-container",
      localized: false,
      required: false,
      showIf: (options) => options.get("iframeContentType") === "elements",
    },
  ],
};
